import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './core/http.service';
import { URLService } from './_url.service';
import { ResponseData } from './model/response.model';
@Injectable({
  providedIn: 'root'
})
export class ReportAnalyticsService {

  constructor(private httpService: HttpService, private URLService: URLService) { }

      GetReport(fromDate: string, toDate: string, reportPeriod: string, year: string, month: string,reportName: string,customer?:string): Observable<ResponseData> {
      return this.httpService.get(this.URLService.GetReport,{fromDate:fromDate,toDate:toDate,reportPeriod:reportPeriod, year:year, month:month, reportName:reportName,customer:customer??''});
      
    }

    GetServicePerformanceReport(fromDate: string, toDate: string, reportPeriod: string, year: string, month: string,reportName: string,customer?:string): Observable<ResponseData> {
      return this.httpService.get(this.URLService.GetServicePerformanceReport,{fromDate:fromDate,toDate:toDate,reportPeriod:reportPeriod, year:year, month:month, reportName:reportName,customer:customer??''});
      
    }

    GetTeamPerformanceReport(fromDate: string, toDate: string, reportPeriod: string, year: string, month: string,reportName: string,employee?:string): Observable<ResponseData> {
      return this.httpService.get(this.URLService.GetTeamPerformanceReport,{fromDate:fromDate,toDate:toDate,reportPeriod:reportPeriod, year:year, month:month, reportName:reportName,employee:employee??''});
      
    }

    GetOrdersOverTimeReport(totalMonthlyOrder:number): Observable<ResponseData> {
      return this.httpService.get(this.URLService.GetOrdersOverTimeReport,{totalMonthlyOrder:totalMonthlyOrder});
      
    }
}
